export const sq = {
    translation: {
        common: {
            trial: "Version Prove",
            expired: "I skaduar",
            renewal: "Rinovim",
            quantity: "Sasi",
            error: "Gabim",
            all: "Të gjitha",
            loading: "Duke u ngarkuar...",
            thank_you: "Faleminderit",
            confirm: "Konfirmo",
            cancel: "Anulo",
            save: "Ruaj",
            add: "Shto",
            edit: "Modifiko",
            delete: "Fshi",
            warning: "Paralajmërim",
            delete_confirm_text: "Ky veprim nuk mund të kthehet mbrapa. Jeni të sigurt që dëshironi ta fshini?",
            click_to_select: "Zgjidh...",
            unit: "Njësia",
            detail: "Detaje",
            done: "U krye",
            search: "Kërko",
            processing: "Duke u procesuar...",
            success: "Sukses",
            total: "Totali",
            none: "Asnjë"
        },
        roles: {
            admin: "Admin",
            barista: "Barista",
            waiter: "Kamarier",
            kitchen: "Kuzhina"
        },
        auth: {
            user_not_found: "Përdoruesi nuk u gjet!",
            welcome: "Mirëseerdhët përsëri",
            subtitle: "Identifikohuni për të menaxhuar dyqanin tuaj të kafesë",
            google_login: "Identifikohu me Google",
            apple_login: "Identifikohu me Apple",
            secure_login: "Hyrje e Sigurt",
            terms_text: "Duke u identifikuar, ju pranoni Kushtet tona të Shërbimit dhe Politikën e Privatësisë."
        },
        sidebar: {
            dashboard: "Paneli i Kontrollit",
            tables: "Tavolinat",
            staff: "Stafi",
            loyalty: "CRM & Besnikëria",
            qr_menu: "Menu QR",
            menu_product: "Menuja & Produktet",
            stock_recipe: "Inventari & Recetat",
            reports: "Raportet",
            settings: "Cilësimet",
            admin_panel: "Paneli i Adminit",
            not_logged_in: "Jo i identifikuar",
            click_to_select: "Zgjidh Profilin",
            switch_profile: "Ndërro Profilin",
            logout: "Dil"
        },
        dashboard: {
            overview: "Përmbledhja e Panelit",
            today: "Sot",
            system_active: "Sistemi Aktiv",
            offline: "Mënyra Offline",
            payment_reminder: "Kujtesë Pagese",
            payment_missing_list: "Pagesa për {{names}} nuk është kryer ende.",
            add_expense: "Shto Shpenzim",
            daily_revenue: "Të ardhurat Ditore",
            open_tables: "Tavolina të Hapura",
            pending_tables: "Porosi në Pritje",
            waiting_approval: "Pret Aprovim",
            active_staff: "Staf Aktiv",
            hourly_revenue: "Të ardhura për Orë",
            hourly_profit: "Fitimi për Orë",
            work_hours: "Orët e Punës",
            hours_24: "24 Orë",
            revenue: "Të ardhurat",
            profit: "Fitimi",
            best_sellers: "Më të shiturit",
            support_modal: { other: "Tjetër" },
            weekly_performance: "Performanca Javore",
            weekly_revenue: "Të ardhurat Javore",
            increase: "Rritje",
            decrease: "Ulje",
            busiest_day: "Dita më e ngarkuar",
            view_report: "Shiko Raportin",
            critical_stock_warning: "Stok Kritik",
            quick_actions: "Veprime të Shpejta",
            x_report: "Raporti X",
            sync: "Sinkronizo",
            backup: "Rezervë (Backup)",
            support: "Mbështetje",
            help_support: "Ndihmë & Mbështetje",
            help_desc: "Si mund t'ju ndihmojmë?",
            report_issue: "Raporto një Problem",
            version: "Versioni",
            topic: "Tema",
            technical: "Problem Teknik",
            suggestion: "Sugjerim",
            other: "Tjetër",
            description: "Përshkrimi",
            desc_placeholder: "Ju lutem përshkruani problemin...",
            send_report: "Dërgo Raportin"
        },
        tables: {
            status: {
                occupied: "E zënë",
                paid: "E paguar",
                reserved: "E rezervuar",
                empty: "E lirë"
            },
            alerts: {
                reservation_time: "Ora e rezervimit:",
                draft_paid: "Porosi Draft e Paguar",
                draft_unpaid: "Porosi Draft"
            },
            title: "Plani i Tavolinave",
            tabs: {
                plan: "Plani",
                history: "Historia"
            },
            filter: {
                all: "Të gjitha"
            },
            actions: {
                finish_edit: "Përfundo Modifikimin",
                edit: "Modifiko Tavolinat",
                add_table: "Shto Tavolinë",
                quick_pay: "Pagesë e Shpejtë",
                reserve: "Rezervo",
                clear: "Pastro"
            },
            card: {
                capacity: "Persona",
                just_now: "Tani",
                total: "Totali",
                has_request: "Kërkesë e Re",
                no_order: "Pa Porosi"
            },
            history: {
                search_placeholder: "Kërko Nr. Fature ose Tavolinë...",
                multi_pay: "Pagesë e Shumëfishtë"
            },
            sections: {
                manage: "Menaxho Seksionet",
                add_placeholder: "Emri i Seksionit të Ri",
                no_sections: "Nuk ka seksione të përcaktuara."
            },
            modal: {
                edit_title: "Modifiko Tavolinën",
                add_title: "Shto Tavolinë",
                name: "Emri i Tavolinës",
                name_placeholder: "p.sh. Tavolina 5",
                section: "Seksioni",
                capacity: "Kapaciteti",
                delete: "Fshi Tavolinën",
                unpaid_warning_title: "Bilanc i papaguar!",
                clear_confirm_title: "Pastro Tavolinën?",
                unpaid_warning_text: "<b>{{name}}</b> ka bilanc të papaguar. Pastrimi i saj do të rivendosë porosinë.",
                clear_confirm_text: "Jeni të sigurt që dëshironi të pastroni <b>{{name}}</b>?",
                delete_confirm_text: "Jeni të sigurt që dëshironi të fshini <b>{{name}}</b>?"
            },
            qr_review: {
                title: "Porosi QR në Ardhje",
                subtitle: "Kërkesë e re nga {{name}}",
                current_state: "Gjendja Aktuale e Tavolinës",
                table_empty: "Tavolina është aktualisht bosh.",
                current_total: "Totali Aktual",
                incoming_request: "Kërkesa në Ardhje",
                extra_total: "Totali Ekstra",
                reject: "Refuzo",
                overwrite: "Mbishkruaj",
                overwrite_desc: "Pastro aktualen & vendos të renë",
                merge: "Bashko",
                merge_desc: "Shto te ekzistuesja"
            }
        },
        orders: {
            status: {
                completed: "E përfunduar"
            },
            list: {
                ticket_no: "Nr. Faturës",
                date: "Data/Ora",
                table: "Tavolina/Klienti",
                method: "Metoda",
                amount: "Shuma",
                status: "Statusi"
            },
            modal: {
                match_error: "Totali i pagesës ({{pay}}₺) nuk përputhet me totalin e porosisë ({{total}}₺).",
                title: "Detajet e Transaksionit",
                content_title: "Përmbajtja e Porosisë",
                total_title: "Shuma Totale",
                payment_details: "Detajet e Pagesës",
                entered_total: "Totali i Futur",
                difference: "Diferenca"
            },
            correction: {
                note_placeholder: "p.sh. Gabim në hyrje nga stafi"
            },
            void_flow: {
                button_update: "Përditëso Statusin / Anulo",
                button_void: "Anulo / Rimburso",
                title_select: "Zgjidh Llojin e Anulimit",
                type_cancel: "Gabim / Kthim",
                type_cancel_desc: "Rikthen Stokun",
                type_wastage: "Humbje / Prishje",
                type_wastage_desc: "Zbret Stokun (Pa Kthim)",
                confirm_cancel_title: "Shëno si Gabim/Kthim",
                confirm_wastage_title: "Shëno si Humbje",
                confirm_cancel_text: "Kjo do të anulojë shitjen dhe do të rikthejë stokun në inventar. Jeni të sigurt?",
                confirm_wastage_text: "Kjo do të anulojë shitjen por stoku do të konsiderohet i PËRDORUR/HUMBUR. Jeni të sigurt?",
                confirm: "KONFIRMO"
            }
        },
        pos: {
            title_quick: "Porosi e Shpejtë",
            title_no_table: "Pa Tavolinë",
            title_table: "{{name}}",
            search_placeholder: "Kërko Produktin...",
            grid: {
                sold_out: "E SHITUR"
            },
            ticket: {
                title: "Fatura Aktuale",
                order_no: "NR POROSISË",
                new: "E RE",
                empty: "Shporta është bosh.",
                status: {
                    wastage: "HUMBJE",
                    comp: "FALAS",
                    cancelled: "ANULUAR",
                    paid: "PAGUAR"
                },
                discount_badge: "ULJE"
            },
            actions: {
                discount: "ZBRITJE",
                comp: "FALAS",
                void: "HUMBJE",
                cancel: "ANULO",
                pay: "PAGUAJ",
                assign_table: "TAVOLINË",
                save: "RUAJ",
                waiting_payment: "PRET PAGESË",
                close_ticket: "MBYLL FATURËN"
            },
            totals: {
                subtotal_net: "Nëntotali (Neto)",
                tax_vat: "Tatimi (TVSH)",
                grand_total: "Totali i Përgjithshëm",
                tax_exclusive_hint: "(+Taksa)"
            },
            alerts: {
                table_not_found: "Tavolina nuk u gjet.",
                parent_comp: "Nuk keni leje për të ofruar produkte falas.",
                perm_void: "Nuk keni leje për të anuluar artikuj.",
                select_item_error: "Ju lutem zgjidhni një artikull.",
                paid_item_error: "Artikujt e paguar nuk mund të modifikohen.",
                split_quantity: "Sa nga {{count}} artikujt dëshironi të lëvizni?",
                invalid_amount: "Shumë e pavlefshme.",
                perm_discount: "Nuk keni leje për të aplikuar zbrtiіje.",
                select_discount_item: "Zgjidhni një artikull për zbrtiіje.",
                paid_discount_error: "Nuk mund të aplikohet zbrtiіje në artikujt e paguar.",
                add_items_first: "Ju lutem shtoni artikuj në shportë fillimisht.",
                unauthorized: "Aksesi u Refuzua"
            },
            modifier_modal: {
                no_modifiers: "Nuk ka modifikues të disponueshëm.",
                multiple: "shumëfishtë",
                add_to_cart: "Shto në Shportë"
            },
            discount_modal: {
                title: "Apliko Zbritje",
                percent: "Përqindje",
                amount: "Shuma",
                comp_100: "FALAS (100%)",
                old_total: "Totali i Vjetër",
                new_total: "Totali i Ri",
                apply: "Apliko Zbritjen"
            }
        },
        payment: {
            alerts: {
                enter_valid: "Ju lutem jepni një shumë të vlefshme.",
                balance_not_zero: "Bilanci i mbetur duhet të jetë 0 për të mbyllur faturën."
            },
            header_order: "Porosia",
            header_open: "Faturë e Hapur",
            ticket_details: "Detajet e Faturës",
            select_all: "Zgjidh të Gjitha",
            items_count: "{{count}} Artikuj",
            empty_list: "Nuk ka artikuj",
            remaining_badge: "Mbetur: {{amount}}",
            recent_transactions: "TRANSAKSIONET E FUNDIT",
            totals: {
                total: "Totali",
                paid: "E paguar",
                remaining: "Mbetur"
            },
            amount_to_collect: "Shuma për t'u mbledhur",
            give_change: "Kusuri",
            return_to_customer: "Ktheja klientit",
            methods: {
                cash: "Para në dorë",
                card: "Kartë Krediti",
                qr: "QR / Mobile",
                other: "Kartë Ushqimi"
            },
            numpad: {
                all: "Të gjitha"
            },
            actions: {
                cancel: "Anulo",
                close_ticket: "Mbyll Faturën",
                waiting_payment: "Pret Pagesë"
            }
        },
        menu: {
            title: "Menaxhimi i Menusë",
            subtitle: "Menaxho produktet, çmimet dhe stokun",
            add_new: "Shto Produkt",
            edit_title: "Modifiko Produktin",
            add_title: "Shto Produkt",
            manage_categories: "Menaxho Kategoritë",
            alerts: {
                no_permission: "Nuk keni leje për të menaxhuar menunë.",
                delete_confirm: "Jeni të sigurt që dëshironi ta fshini këtë produkt?"
            },
            form: {
                image_select: "Zgjidh Imazhin",
                image_change: "Ndërro Imazhin",
                image_recommendation: "Rekomandohet formati katror",
                image_max_size: "Maks 2MB",
                name: "Emri i Produktit",
                name_placeholder: "p.sh. Latte",
                category: "Kategoria",
                price: "Çmimi",
                stock_tracking: "Ndjekja e Stokut",
                stock_hint: "Lini 0 për ta çaktivizuar",
                description: "Përshkrimi",
                description_placeholder: "Përbërësit, detajet...",
                customizable: "I personalizueshëm (Modifikues)"
            },
            categories: {
                title: "Menaxhimi i Kategorive",
                add: "Shto Kategori",
                name: "Emri i Kategorisë",
                edit: "Modifiko Kategorinë",
                delete_confirm: "Fshini këtë kategori?"
            }
        },
        categories: {
            all: "Të gjitha",
            hot_coffees: "Kafe të Ngrohta",
            cold_coffees: "Kafe të Ftohta",
            desserts: "Ëmbëlsira",
            snacks: "Snacks",
            barista_special: "Specialitete"
        },
        stock: {
            title: "Menaxhimi i Inventarit",
            subtitle: "Stoku, Recetat dhe Modifikuesit",
            tabs: {
                inventory: "Inventari",
                recipes: "Recetat",
                modifiers: "Modifikuesit"
            },
            inventory: {
                total_value: "Vlera Totale",
                sku_count: "Numri i Artikujve",
                alerts: "Alarmet e Stokut",
                search_placeholder: "Kërko në Stok...",
                add_stock: "Shto Artikull",
                status_critical: "Kritik",
                status_warning: "I Ulët",
                status_sufficient: "Në rregull",
                table: {
                    name: "Emri",
                    supplier: "Furnizuesi",
                    amount: "Sasia",
                    status: "Statusi",
                    unit_cost: "Kostoja për Njësi",
                    actions: "Veprime"
                },
                modal: {
                    edit_title: "Modifiko Stokun",
                    add_title: "Shto Stok",
                    general_info: "Informacion i Përgjithshëm",
                    management: "Menaxhimi",
                    name: "Emri i Artikullit",
                    name_placeholder: "p.sh. Qumësht",
                    supplier: "Furnizuesi",
                    supplier_placeholder: "p.sh. Ferma Lokale",
                    unit: "Njësia",
                    alarm_thresholds: "Pragjet e Alarmit",
                    warning_limit: "Limiti i Paralajmërimit",
                    critical_limit: "Limiti Kritik",
                    stock_status: "Statusi i Stokut",
                    finish_editing: "Përfundo Modifikimin",
                    manual_correction: "Korrigjim Manual",
                    current_amount: "Sasia Aktuale",
                    unit_cost: "Kostoja për Njësi",
                    new_purchase: "Blerje e Re / Hyrje",
                    add_amount: "Shto Sasinë",
                    purchase_price: "Çmimi i Blerjes",
                    total: "Totali",
                    unit_price: "Çmimi për Njësi",
                    success_feedback: "U përditësua!",
                    calculate_add: "Llogarit & Shto",
                    avg_cost_note: "* Llogarit koston mesatare të ponderuar."
                }
            },
            wastage: {
                title: "Raporto Humbjet",
                subtitle: "Raportimi i humbjeve për {{name}}",
                amount: "Sasia",
                reason: "Arsyeja",
                reason_placeholder: "p.sh. E derdhur, E prishur",
                report: "Raporto Humbjen"
            },
            recipes: {
                search_product: "Kërko produktin...",
                gross_margin: "Marzhi Bruto",
                sale_price: "Çmimi i Shitjes",
                cost_price: "Çmimi i Kostos",
                ingredients: "Përbërësit",
                no_recipe: "Nuk ka recetë të përcaktuar.",
                add_ingredient: "Shto Përbërës",
                stock_item: "Artikull Stoku",
                amount: "Sasia",
                unit: "Njësia"
            },
            modifiers: {
                title: "Grupet e Modifikuesve",
                new_group: "Grup i Ri",
                group_name: "Emri i Grupit",
                selection_type: "Lloji i Seleksionimit",
                single: "Njësh (Radio)",
                multiple: "Shumëfishtë (Checkbox)",
                options: "Opsionet",
                option_name: "Emri i Opsionit",
                option_placeholder: "p.sh. Qumësht Ovshre",
                extra_price: "Çmim Ekstra",
                deduct_stock: "Zbrit Stokun (Opsionale)",
                add_option: "Shto Opsion",
                group_helper_text: "Menaxho opsionet për këtë grup më poshtë.",
                no_link: "Pa Lidhje",
                stock_optional_label: "Stoku (Opsionale)",
                edit_group_title: "Modifiko Grupin",
                allow_multiple_label: "Lejo seleksionime të shumta (Checkbox)",
                delete_group_confirm: "Jeni të sigurt që dëshironi ta fshini këtë grup?"
            }
        },
        reports: {
            title: "Përmbledhja Financiare",
            filters: { today: "Sot", week: "Javë", month: "Muaj", all: "Të gjitha" },
            kpi: {
                revenue: "Totali i të Ardhurave",
                net_revenue: "Të ardhurat Neto (Pa Taksa)",
                tax_collected: "Taksa e Mbledhur",
                income: "Hyrje",
                expense: "Totali i Shpenzimeve",
                expense_opr: "Operacionale",
                expense_stock: "COGS (Kosto e Mallit)",
                expense_wastage: "Humbje",
                profit: "Fitimi Neto",
                profit_opr: "Fitimi Operacional",
                cash_in_hand: "Fluksi i Parasë",
                gross_profit: "Fitimi Bruto",
                tickets: "Totali i Faturave",
                sales_count: "Numri i Shitjeve",
                expense_analysis: "Analiza e Shpenzimeve",
                profit_analysis: "Analiza e Fitimit Neto",
                available_in_standard: "E disponueshme në Planin Standard",
                locked: "E bllokuar"
            },
            toggles: {
                stock_cost: "Kostoja e Stokut",
                wastage: "Humbjet",
                operational: "Mënyra Operacionale",
                net_revenue: "Të ardhurat Neto (Taksa)"
            },
            charts: {
                sales_title: "Grafiku i Shitjeve ({{currency}})",
                hourly: "Për Orë",
                daily: "Ditore",
                monthly: "Mujore",
                distribution: "Shpërndarja",
                category_breakdown: "Ndarja sipas Kategorive",
                revenue_share: "Ndarja e të Ardhurave",
                no_data: "Nuk ka të dhëna.",
                tooltip_revenue: "Të ardhurat: ",
                tooltip_net_revenue: "Të ardhurat Neto: ",
                tooltip_profit: "Fitimi: "
            },
            transactions: {
                title: "Historia e Transaksioneve",
                count_listed: "{{count}} Rekorde të Listuara",
                table: {
                    ticket_no: "Nr. Faturës",
                    date: "Data / Ora",
                    table: "Tavolina",
                    method: "Metoda",
                    amount: "Shuma",
                    status: "Statusi"
                },
                status: {
                    completed: "E përfunduar",
                    cancelled: "E anuluar"
                },
                no_records: "Nuk u gjetën transaksione në periudhën e zgjedhur."
            },
            x_report: {
                title: "Raporti i Momentit (Raporti-X)",
                total_cash: "Totali i Parave në Arkë",
                daily_tickets: "Faturat Ditore",
                cancelled_trx: "Transaksione të Anuluara",
                collections: "Mbledhjet (Aktuale)",
                shift_reports: "Raportet e Ndërresave (Sot)",
                no_shift: "Nuk ka ende raporte ndërresash.",
                total_sales: "TOTALI I SHITJEVE",
                cash: "Para në dorë",
                credit_card: "Kartë Krediti",
                qr_mobile: "QR / Mobile",
                meal_card: "Kartë Ushqimi"
            },
            z_report: {
                title: "Raporti i Mbylljes (Raporti-Z)",
                auto_toggle: "Raport-Z Automatik",
                auto_desc: "Në orën 00:00",
                close_button: "MBYLL DITËN (RAPORTI-Z)",
                history_title: "Raportet-Z të Kaluara",
                no_reports: "Nuk ka ende raporte.",
                receipt: {
                    title: "RAPORTI Z",
                    report_no: "Nr. Raportit",
                    cashier: "Arkatari",
                    total_sales: "TOTALI I SHITJEVE",
                    tax_base: "Baza Tatimore",
                    total_tax: "Totali i Taksave",
                    payment_details: "Detajet e Pagesës",
                    cash: "Para në dorë",
                    card: "Kartë Krediti",
                    other: "Tjetër",
                    end: "--- FUND ---"
                }
            },
            modals: {
                close_confirm: {
                    title: "Mbyll Ditën?",
                    text: "Ky veprim do të arkivojë <strong>{{count}}</strong> transaksione të hapura dhe do të gjenerojë një Raport-Z zyrtar. Nuk mund të kthehet mbrapa.",
                    cancel: "Anulo",
                    confirm: "Konfirmo & Mbyll"
                },
                expense: {
                    title: "Shto Shpenzim të Shpejtë",
                    date: "Data",
                    category: "Kategoria",
                    amount: "Shuma",
                    description: "Përshkrimi",
                    optional: "Opsionale...",
                    set_default: "Vendos si të paracaktuar për kategorinë",
                    last_trx: "Fundit: {{amount}} ({{date}})"
                },
                processing: {
                    title: "Duke gjeneruar Raportin-Z...",
                    text: "Ju lutem prisni, duke procesuar mbylljen e ditës..."
                }
            },
            liabilities: {
                pending: "Pagesat në Pritje",
                label_today: "Pjesa e Shpenzimeve Sot",
                label_week: "Pjesa e Shpenzimeve Javore",
                label_total: "Pagesat Periodike në Pritje"
            }
        },
        settings: {
            general: "Cilësimet e Përgjithshme",
            titles: {
                general: "Të përgjithshme",
                expenses: "Shpenzimet",
                modifiers: "Modifikuesit",
                developer: "Zhvilluesi"
            },
            descriptions: {
                general: "Sistemi, gjuha dhe cilësimet e biznesit",
                expenses: "Konfigurimi financiar",
                developer: "Mjete për simulim dhe testim"
            },
            subscription: {
                active: "AKTIV",
                inactive: "JO AKTIV",
                expired: "I SKADUAR",
                renew: "Rinovon",
                days_left: "Ditë të mbetura",
                next_payment: "Pagesa e radhës",
                period_start: "Fillimi i periudhës",
                time_remaining: "Koha e mbetur",
                lite_plan: "Plani Lite",
                standard_plan: "Plani Standard"
            },
            business_identity: "Identiteti i Biznesit",
            financial: "Cilësimet Financiare",
            financial_desc: {
                currency_desc: "Simboli i përdorur në të gjithë sistemin",
                pricing_desc: "Metoda e llogaritjes së taksave"
            },
            interface: {
                title: "Ndërfaqja",
                scale: "Shkalla e UI (Zoom)",
                scale_desc: "Rregulloni shkallën për artikujt që nuk përshtaten ose duken shumë të vegjël/mëdhenj.",
                note: "Shënim:",
                scale_note: "Auto-shkallëzimi është gjithmonë aktiv në ekranet më të vegjël se 1366px."
            },
            operational: {
                title: "Orari i Punës & Ndërresat",
                start_hour: "Ora e Fillimit (0-23)",
                end_hour: "Ora e Mbarimit (0-23)",
                info_text: "Ky cilësim përcakton diapazonin kohor të shfaqur në grafikun e shitjeve për orë në **Panelin e Kontrollit**. Përdoret gjithashtu si referencë për raportimin e ndërresave të stafit.",
                updated_alert: "Orari i punës u përditësua."
            },
            shortcuts: {
                staff_desc: "Menaxho Kamarierët, Baristat dhe Adminët"
            },
            backup: {
                title: "Të dhënat & Rezerva",
                backup_now: "Ruaj Rezervë",
                backup_desc: "Shkarko Databazën (.json)",
                restore: "Rikthe",
                restore_desc: "Zgjidh skedarin .json",
                factory_reset: "Rivendosje në Fabrikë",
                reset_desc: "Të gjitha të dhënat do të fshihen dhe do të kthehen në gjendjen fillestare.",
                reset_button: "Fshi të dhënat",
                success_restore: "Rezerva u rikthye me sukses."
            },
            security: {
                reset_title: "Rivendosje në Fabrikë",
                restore_title: "Rikthe nga Rezerva",
                reset_text: "Ky veprim nuk mund të kthehet mbrapa. Të gjitha të dhënat (shitjet, produktet, stoku) do të fshihen përgjithmonë.",
                restore_text: "Të dhënat aktuale do të fshihen dhe do të ngarkohen të dhënat nga skedari i përzgjedhur.",
                admin_required: "Kërkohet Aprovimi i Adminit",
                enter_pin: "Ju lutem jepni PIN-in",
                confirm_reset: "Fshi & Rivendos",
                confirm_restore: "Fillo Rikthimin"
            },
            messages: {
                updated: "Cilësimet u përditësuan.",
                error: "Ndodhi një gabim."
            },
            sync: {
                title: "Sinkronizimi në Re (Cloud)",
                pending: "{{count}} artikuj në pritje",
                up_to_date: "Të gjitha të dhënat janë të përditësuara",
                button: "Sinkronizo Tani"
            }
        },
        financials: {
            title: "Cilësimet Financiare",
            subtitle: "Normat e Taksave & Kategoritë e Shpenzimeve",
            tabs: {
                taxes: "Taksat",
                expenses: "Shpenzimet",
                history: "Historia e Shpenzimeve"
            },
            taxes: {
                title: "Normat e Taksave",
                active_rates: "Normat Aktive",
                rate_name: "Emri i Normës",
                rate_percent: "Norma %",
                description: "Përshkrimi",
                add_new: "Shto Normë të Re",
                category_mapping: "Lidhja e Taksave me Kategoritë"
            },
            expenses: {
                title: "Kategoritë e Shpenzimeve",
                add_new: "Shto Kategori",
                category_name: "Emri i Kategorisë",
                description: "Përshkrimi",
                default_amount: "Shuma e Paracaktuar",
                recurring: "Periodike (Mujore)",
                recurring_day: "Dita e Muajit",
                distribute_daily: "Shpërndaj në mënyrë ditore në raporte"
            },
            history: {
                title: "Historia e Shpenzimeve",
                filter_all: "Të gjitha kategoritë",
                no_records: "Nuk u gjetën rekorde.",
                table: {
                    date: "Data",
                    category: "Kategoria",
                    description: "Përshkrimi",
                    amount: "Shuma"
                }
            }
        },
        crm: {
            title: "CRM & Besnikëria",
            subtitle: "Menaxhimi i Klientit & Programi i Besnikërisë",
            give_points: "Jep Pikë",
            qr_instruction: "Skano kodin QR për klientin",
            generate_qr: "Gjenero QR",
            qr_description: "Tregojani këtë kod QR klientit për të shtuar pikë në portofolin e tyre.",
            customer_list: "Lista e Klientëve",
            search_placeholder: "Kërko Klientin...",
            last_visit: "Vizita e Fundit:",
            eligible: "Shpërblim i Disponueshëm!",
            settings_title: "Cilësimet e Fushatës",
            target_points: "Pikët Objektiv",
            reward_name: "Emri i Shpërblimit",
            preview: "Parashikimi i Kartës",
            target_label: "Objektivi",
            coming_soon: "Së Shpejti"
        },
        qr: {
            title: "Menu QR",
            subtitle: "Menuja Digjitale & Sistemi i Porositjes",
            simulate: "Simulo Porosinë",
            print_selected: "Printo të Zgjedhurat",
            lock: {
                title: "Shërbimet Online të Bllokuara",
                desc: "Menuja QR dhe veçoritë e porositjes online janë të disponueshme në Planin Standard.",
                upgrade_btn: "Përmirëso Planin"
            },
            print: {
                title: "Printo Kodet QR",
                scan_instruction: "Skano për të parë Menunë"
            },
            preview: {
                title: "Parashikimi Live",
                network: "Rrjeti:",
                password: "Fjalëkalimi:",
                powered_by: "Mundësuar nga KahveInn",
                disclaimer: "* Ky është një parashikim se si do të duket mbajtësja QR.",
                scan_instruction: "Skano për Menu"
            },
            settings: {
                general: "Të përgjithshme",
                active: "Aktiv",
                active_desc: "Aktivizo sistemin e Menusë QR",
                ordering: "Lejo Porositjen",
                ordering_desc: "Klientët mund të bëjnë porosi",
                sound: "Alarm me Zë",
                sound_desc: "Luaj zë për çdo porosi të re",
                design: "Dizajni",
                header_text: "Teksti i Kokës",
                theme_color: "Ngjyra e Temës",
                wifi_ssid: "Emri i Wi-Fi (SSID)",
                wifi_pass: "Fjalëkalimi i Wi-Fi"
            },
            selection: {
                title: "Zgjedhja e Tavolinës",
                select_all: "Zgjidh të Gjitha",
                previewing: "Duke u parashikuar"
            },
            modal: {
                permission_title: "Kërkohet Leje",
                permission_text: "Na nevojitet leja e shfletuesit për të luajtur njoftimet me zë.",
                allow_btn: "Lejo Zërin"
            }
        },
        staff: {
            title: "Menaxhimi i Stafit",
            subtitle: "Punonjësit dhe autorizimet",
            tabs: {
                list: "Lista e Stafit",
                roles: "Rolet & Lejet"
            },
            lite_banner: {
                title: "Plani Lite",
                desc: "Menaxhimi i avancuar i stafit është i kufizuar."
            },
            stats: {
                total: "Totali i Stafit",
                on_duty: "Në Punë"
            },
            matrix: {
                person: "Personi"
            },
            auto_shift_report: "Raport Automatik i Ndërresës",
            modal: {
                add_title: "Shto Staf",
                edit_title: "Modifiko Stafin",
                delete: "Fshi Stafin",
                name: "Emri i Plotë",
                role: "Roli",
                pin: "Kodi PIN (4-shifra)",
                phone: "Telefoni (Opsionale)",
                status: "Statusi",
                status_working: "Duke Punuar",
                status_off: "Jashtë Pune"
            },
            roles_tab: {
                title: "Rolet",
                subtitle: "Personalizo lejet e roleve",
                permissions: "Lejet",
                no_permissions: "Nuk ka leje të caktuara"
            },
            contact: "Kontakt",
            status: {
                working: "Duke Punuar",
                offline: "Jashtë Pune"
            },
            permission_matrix: "Matrica e Lejeve",
            no_pin_permission: "Nuk ka leje për të parë/ndryshuar PIN-in",
            unauthorized_tooltip: "Nuk mund ta modifikoni këtë përdorues",
            alerts: {
                no_add_permission: "Nuk keni leje për të shtuar staf.",
                no_edit_others: "Ju mund të modifikoni vetëm profilin tuaj.",
                no_edit_admin: "Vetëm Adminët mund të modifikojnë Adminët.",
                no_delete_self: "Nuk mund të fshini veten tuaj.",
                no_delete_permission: "Nuk keni leje për të fshirë staf.",
                no_delete_admin: "Vetëm Adminët mund të fshijnë Adminët.",
                delete_confirm: "Jeni të sigurt që dëshironi ta fshini këtë anëtar të stafit?",
                no_status_admin: "Vetëm Adminët mund të ndryshojnë statusin e Adminit.",
                only_admin_roles: "Vetëm Adminët mund të ndryshojnë lejet e roleve."
            }
        },
        permission_groups: {
            general: "Të përgjithshme",
            sales: "Shitjet",
            management: "Menaxhimi"
        },
        permissions: {
            VIEW_FINANCIALS: { label: "Shiko Financat", description: "Aksesi në të dhënat e të ardhurave dhe fitimit" },
            VIEW_TABLES: { label: "Shiko Tavolinat", description: "Shiko planin e tavolinave dhe porositë" },
            MANAGE_MENU: { label: "Menaxho Menunë", description: "Shto dhe modifiko produktet" },
            MANAGE_STOCK: { label: "Menaxho Stokun", description: "Kontrolli i inventarit" },
            VIEW_REPORTS: { label: "Shiko Raportet", description: "Aksesi në faqet e raporteve" },
            MANAGE_STAFF: { label: "Menaxho Stafin", description: "Shto/hiq pjesëtarë të stafit" },
            MANAGE_SETTINGS: { label: "Menaxho Cilësimet", description: "Konfigurimi i sistemit" },
            VOID_ITEM: { label: "Anulo Artikullin", description: "Operacionet e anulimit ose humbjeve" },
            OFFER_COMP: { label: "Ofro Falas", description: "Leja për të dhënë artikuj falas" },
            APPLY_DISCOUNT: { label: "Apliko Zbritje", description: "Apliko zbritje në porosi" },
            CLOSE_DAY: { label: "Mbyll Ditën", description: "Leja për të nxjerrë Raportin-Z" }
        },
        setup: {
            business_name: "Emri i Biznesit",
            business_address: "Adresa",
            manager_name: "Emri i Menaxherit",
            manager_hint: "Emri juaj për profilin e menaxherit",
            staff_count: "Numri i Stafit",
            staff_hint: "Numri i parashikuar i punonjësve",
            currency: "Monedha",
            pricing_model: "Modeli i Çmimit",
            tax_inclusive: "Me Taksa të Përfshira",
            tax_exclusive: "Pa Taksa të Përfshira",
            completing: "Duke përfunduar konfigurimin...",
            title_1: "Mirëseerdhët",
            title_2: "Ekipi & Menaxhimi",
            title_3: "Cilësimet Financiare",
            desc_1: "Le të krijojmë identitetin e biznesit tuaj.",
            desc_2: "Le të konfigurojmë strukturën e ekipit tuaj.",
            desc_3: "Zgjidhni preferencat tuaja për monedhën dhe taksat.",
            skip_dev: "Kalo (Zhvillues)",
            back: "Mbrapa",
            next: "Para",
            finish: "Përfundo Konfigurimin",
            placeholders: {
                business_name: "p.sh. KahveInn",
                city: "Qyteti (p.sh. Tiranë)",
                district: "Lagjja",
                address_detail: "Rruga, Nr. i ndërtesës...",
                manager_name: "Emri juaj i plotë"
            },
            errors: {
                business_name: "Ju lutem shkruani emrin e biznesit.",
                city: "Ju lutem shkruani qytetin.",
                district: "Ju lutem shkruani lagjen.",
                address_detail: "Ju lutem shkruani adresën e plotë.",
                manager_name: "Ju lutem shkruani emrin e menaxherit.",
                staff_count: "Ju lutem shkruani një numër të vlefshëm të stafit."
            },
            currencies: {
                try: "Lira Turke (₺)",
                usd: "Dollar Amerikan ($)",
                eur: "Euro (€)",
                gbp: "Sterlina Britanike (£)"
            },
            loading_text: "Sistemi juaj po përgatitet, ju lutem prisni."
        }
    }
};